// Logger akses SIORMAS untuk AKUN AHU (Administrasi Hukum Umum).
// No-op kecuali akun yang login ber-flag is_ahu === true (lihat ahuActivity.js).
// Mencatat: (a) setiap menu/halaman yang dibuka, dan (b) aksi data ala BAKUM
// (detail/search/download). Dikirim ke audit service (category 'AHU_ACCESS')
// via storeActivitySilent — fire-and-forget, tidak boleh ganggu UX/navigasi.
import store from '@/core/services/store';
import { buildAhuActivity, menuLabel } from './ahuActivity';

function getCurrentUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch (_e) {
    return {};
  }
}

function formatWaktu(d) {
  // Output: "01/05/26 14.32" (id-ID locale) — sama gaya dengan bakumLogger.
  return d.toLocaleString('id-ID', { dateStyle: 'short', timeStyle: 'short' });
}

function dispatchSilent(payload) {
  if (!payload) return;
  try {
    store.dispatch('storeActivitySilent', payload);
  } catch (_e) {
    // diam — log tidak boleh memicu error pada alur utama
  }
}

/**
 * Catat akun AHU membuka sebuah menu/halaman. Dipanggil terpusat dari router guard.
 * @param {object|string} route — route object Vue Router (punya .path) atau string path.
 */
export function logAhuMenu(route) {
  if (!localStorage.getItem('token')) return; // belum login / public, skip
  const path = route && (route.path || route.fullPath) ? (route.path || route.fullPath) : route;
  const payload = buildAhuActivity(getCurrentUser(), 'menu', {
    label: menuLabel(path),
    waktu: formatWaktu(new Date())
  });
  dispatchSilent(payload);
}

/**
 * Catat aksi data akun AHU (gaya BAKUM): membuka detail, mencari, atau mengunduh.
 * @param {string} type — 'detail' | 'search' | 'download' | 'export'.
 * @param {string} entitas — kata kunci / nama entitas.
 */
export function logAhuAction(type, entitas) {
  if (!localStorage.getItem('token')) return;
  const payload = buildAhuActivity(getCurrentUser(), type, {
    entitas: entitas,
    waktu: formatWaktu(new Date())
  });
  dispatchSilent(payload);
}
